import { render, staticRenderFns } from "./income-deduction-dialog.vue?vue&type=template&id=497e3c4a&scoped=true&"
import script from "./income-deduction-dialog.vue?vue&type=script&lang=js&"
export * from "./income-deduction-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e3c4a",
  null
  
)

export default component.exports